import BaseModel from '@/app-core/lib/data/model/BaseModel'
import CustomerAddressResource from '@/app-core/api/resources/customer/CustomerAddressResource'
import CheckoutAddressValidator from '@/app-core/api/validations/checkout/CheckoutAddressValidator'

export default class CheckoutAddressModel extends BaseModel {
  constructor(payload = {}, resource = CustomerAddressResource, validator = CheckoutAddressValidator) {
    super(payload, resource, validator)
  }

  boot() {
    super.boot()

    this.guarded = ['useCustomAddress']
  }

  /* PROPERTIES */

  /* METHODS */
}
